import { useState, type FormEvent } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Store } from 'lucide-react'
import { FloatingInput } from '@/components/FloatingInput'
import { supabase } from '@/lib/supabase'

export default function Login() {
  const navigate = useNavigate()
  const [form, setForm] = useState({ email: '', password: '' })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setLoading(true)
    setError('')

    const { error } = await supabase.auth.signInWithPassword({
      email: form.email,
      password: form.password,
    })

    setLoading(false)

    if (error) {
      setError('Username atau password salah.')
      return
    }

    navigate('/')
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-12 h-12 bg-blue-600 rounded-2xl flex items-center justify-center mb-3">
            <Store size={24} className="text-white" />
          </div>
          <h1 className="text-xl font-bold text-gray-900">Masuk</h1>
          <p className="text-sm text-gray-400 mt-1">Selamat datang kembali</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 flex flex-col gap-4">
          <FloatingInput
            label="Email"
            type="email"
            value={form.email}
            onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
          />
          <FloatingInput
            label="Password"
            type="password"
            value={form.password}
            onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
          />

          {error && <p className="text-xs text-red-500 -mt-1">{error}</p>}

          <button
            type="submit"
            disabled={!form.email || !form.password || loading}
            className={`w-full py-3 rounded-xl font-semibold text-sm transition-colors ${
              !form.email || !form.password || loading
                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700'
            }`}
          >
            {loading ? 'Memproses...' : 'Masuk'}
          </button>
        </form>

        <p className="text-center text-sm text-gray-400 mt-4">
          Belum punya akun?{' '}
          <Link to="/register" className="text-blue-600 font-medium hover:underline">
            Daftar
          </Link>
        </p>

        <div className="text-center mt-3">
          <Link to="/" className="text-xs text-gray-400 hover:text-gray-600">
            ← Kembali ke beranda
          </Link>
        </div>
      </div>
    </div>
  )
}
